import { Box } from '@material-ui/core';
import React, { FC } from 'react';
import { FieldTextInput } from '../../components';
import Heading from './Heading';
import Subheading from './Subheading';
import { ListingFlowFormField } from './ListingFlowTypes';
import { useListingFlowConfig } from '../../hooks/useListingFlowConfig';

const Description: FC = () => {
  const { descriptionHelperText } = useListingFlowConfig();

  const placeholder = 'e.g. Great item in pristine condition, only used once. Selling because...';

  return (
    <>
      <Heading>Description</Heading>
      {!!descriptionHelperText && <Subheading>{descriptionHelperText}</Subheading>}
      <Box pt={1}>
        <FieldTextInput
          key={ListingFlowFormField.Description}
          id={ListingFlowFormField.Description}
          name={ListingFlowFormField.Description}
          type="textarea"
          placeholder={placeholder}
        />
      </Box>
    </>
  );
};

export default Description;
